<template>
  <form v-if="phoneValidate" class="form" @submit.prevent="">
    <h2 class="form__title">Восстановление пароля</h2>
    <div class="form__description">
      <p>
        Для&nbsp;восстановления пароля позвоните с&nbsp;номера <b class="_g-text-no-wrap">{{ phone }}</b> по&nbsp;номеру, указанному ниже. Звонок бесплатный. Переход произойдет автоматически в&nbsp;течение пяти секунд после звонка.
      </p>

      <h2>
        <a class="form__link" :href="`tel:+${phoneValidate.data.callDetails.confirmationNumber}`">
          {{ phoneValidate.data.callDetails.confirmationNumber | VMask('+# (###) ###-##-##') }}
        </a>
      </h2>
    </div>

    <div class="form-row form-row_mobile-wrap form__actions">
      <div class="form__nav" v-if="resendTimeLeft > 0">
        <p>
          Запросить другой номер через&nbsp;<b>{{ resendTimeLeft }}&nbsp;сек</b>
        </p>
      </div>
      <button
        class="form__submit button button__lg button__blue"
        type="submit"
        :disabled="resendTimeLeft > 0"
        @click="verifyPhone"
      >
        запросить заново
      </button>
    </div>

    <div class="reset-password__footer">
      <ul class="reset-password__links">
        <li>
          Вспомнили пароль?
          <router-link :to="{ name: 'login' }" class="form__link">
            Войти
          </router-link>
        </li>
        <li>
          <a href="#" class="form__link" @click.prevent="changePhone">
            Изменить мой номер
          </a>
        </li>
      </ul>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import api from "../services/api";

const REFRESH_TIMEOUT = 60

export default {
  name: "ResetPasswordStep2",
  props: {
    phone: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      hasError: false,
      phoneValidate: null,
      resendTimeLeft: 0,
      checkInterval: null
    };
  },
  created() {
    this.verifyPhone();
  },
  methods: {
    async verifyPhone() {
      this.$store.dispatch("showLoader");

      try {
        this.phoneValidate = await api.verifyPhoneByCall(String(this.phone.replace(/\D/g, "")));
        this.startTimer();
      } finally {
        this.$store.dispatch("hideErrorsBag");
        this.$store.dispatch("hideLoader");
      }
    },
    async phoneByCallCheck() {
      try {
        if (this.resendTimeLeft % 5 === 0) {
          const callId = await api.verifyPhoneByCallCheck(this.phoneValidate?.data?.callDetails?.callId);
          if (callId) {
            this.stopTimer();
            this.$emit('complete', 3);
            this.$store.dispatch('hideErrorsBag');
          }
        }

        if (this.resendTimeLeft > 0) {
          this.resendTimeLeft--;
        }
      } catch (e) {
        this.$store.dispatch('setErrors', e);
      }
    },
    startTimer() {
      this.stopTimer();
      this.resendTimeLeft = REFRESH_TIMEOUT;
      this.checkInterval = setInterval(this.phoneByCallCheck, 1000);
    },
    stopTimer() {
      this.resendTimeLeft = 0;
      clearInterval(this.checkInterval);
    },
    changePhone() {
      this.$emit('complete', 1);
    }
  },
  beforeDestroy() {
    this.stopTimer();
  }
};
</script>
